export type BranchClientLogo = {
  base64: string
  contentId: string
  dataUrl: string
  fileName: string
  mimeType: string
}

export const BRANCH_CLIENT_LOGO_CONTENT_ID = 'daisy-branch-client-communications-logo'

export function parseBranchClientLogo(base64: string | null | undefined): BranchClientLogo | null {
  if (!base64) return null

  let mimeType: string | null = null
  if (base64.startsWith('iVBORw0KGgo')) mimeType = 'image/png'
  else if (base64.startsWith('/9j/')) mimeType = 'image/jpeg'
  else if (base64.startsWith('R0lGOD')) mimeType = 'image/gif'
  else if (base64.startsWith('Qk')) mimeType = 'image/bmp'

  if (!mimeType) return null

  const extension = mimeType === 'image/jpeg' ? 'jpg' : mimeType.split('/')[1]
  return {
    base64,
    contentId: BRANCH_CLIENT_LOGO_CONTENT_ID,
    dataUrl: `data:${mimeType};base64,${base64}`,
    fileName: `branch-client-communications-logo.${extension}`,
    mimeType,
  }
}
